export default {
  LocationAnalysisModal: {
    title: '地理位置分析',
  },
  brand: {
    brandTitle: '品牌',
    hotBrand: '热门品牌',
    allBrand: '全部品牌',
    tips: {
      max: '最多选择{0}个',
    },
    search: '搜索',
    selected: '已选择',
  },
  category: {
    categoryTitle: '分类',
    tips: {
      max: '最多选择{0}个',
    },
  },
  selected: {
    title: '所选商城',
    downloadTitle: '已选主商城',
  },
  selectedBrand: {
    title: '所选品牌',
  },
  selectedFavorite: {
    title: '所选收藏夹',
  },
  exportFormat: {
    title: '选择导出模板',
    tips: {
      max: '最多选择{0}个',
    },
  },
  group: {
    title: '按收藏夹导出',
    noData: '没有数据',
    tips: {
      max: '最多选择{0}个',
    },
  },
  shop: {
    title: '筛选条件',
    continent: '大洲',
    marked: '国家',
    shopType: '商城类型',
    tips: {
      max: '最多选择{0}个',
    },
    all: '全部',
    shop: '商城',
    downloadTitle: '主商城搜索',
  },
};
